import { LogoWhite } from "../assets/icons";

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Modal, Select } from "antd";
import { EnvironmentOutlined, ShoppingOutlined } from "@ant-design/icons";
import { QRCode } from "react-qrcode-logo";
import { HiOutlineQrCode } from "react-icons/hi2";
// import { useSelector } from "react-redux";
// import { AiOutlineShoppingCart } from "react-icons/ai";

const Option = Select.Option;

const Header = ({
  openLoginModal,
  organisation,
  organise,
  merchantee,
  titleComponent,
  merchantLink,
  inOrganise,
  merchantBranches = [],
  selectedBranchDetails,
  onBranchSelect,
  selectedBranchId
}) => {
  const [showProfile, setShowProfile] = useState(false);
  // const [cartItemNumber, setCartItemNumber] = useState(0);
  // const { carts, loading } = useSelector((state) => state.Order);
  const [merchantUrl, setMerchantUrl] = useState("");

  const storedMerchant = localStorage.getItem("merchant_details");
  const merchant = storedMerchant ? JSON.parse(storedMerchant) : "";
  const storageUser = localStorage.getItem("user_customer_details");
  let user = null;
		try {
		  if (storageUser && typeof storageUser === "string") {
		    user = JSON.parse(storageUser);
		  }
		} catch (err) {
		  console.error("Error parsing user from storage:", err);
		}

  const getQRCodeValue = () => {
    return user?.phone_number ? user.phone_number : '';
  };

  useEffect(() => {
    setMerchantUrl(JSON.parse(localStorage.getItem("urewards_merchant_url")));
    // console.log(merchantUrl);
  }, [merchantUrl]);

  const logoutUser = () => {
    localStorage.removeItem("user_customer_details");
    window.location.reload();
  };

  // Brand shown on the left of the header (merchant, organisation, or Loystar).
  const brandLogo = organise
    ? organisation?.organisation_logo || LogoWhite
    : merchantee
    ? merchant?.image || LogoWhite
    : null;
  const brandName = organise
    ? organisation?.organisation_name || organisation?.name || ""
    : merchantee
    ? merchant?.business_name || ""
    : process.env.REACT_APP_BRAND_NAME || "Loystar";

  const initials = (user?.first_name || "U").trim().charAt(0).toUpperCase();
  const showBranchPicker =
    merchantLink !== undefined &&
    merchantBranches &&
    merchantBranches.length >= 1 &&
    onBranchSelect;

  return (
    <>
      {showProfile && (
        <Modal
          open={showProfile}
          onCancel={() => setShowProfile(false)}
          className="profile_modal"
          footer={null}
          centered
        >
          <div className="sign_up_content">
            <p className="ls-pass__eyebrow">Your member pass</p>
            <h3 className="ls-pass__name">
              {user?.first_name ? `Hi, ${user.first_name}` : "Welcome"}
            </h3>

            <div className="ls-pass__qr">
              <QRCode
                size={220}
                quietZone={16}
                value={getQRCodeValue()}
                bgColor="#FFFFFF"
                fgColor="#0F0F10"
                qrStyle="dots"
                ecLevel="H"
                eyeRadius={[
                  {
                    outer: [10, 10, 0, 10],
                    inner: [0, 10, 10, 10],
                  },
                  [10, 10, 10, 0],
                  [10, 0, 10, 10],
                ]}
              />
            </div>
            <p className="ls-pass__hint">
              Show this code at the counter to collect points
            </p>

            {user?.address && (
              <div className="contact_address">
                <div className="contact">
                  <p>Phone Number</p>
                  <p>{user?.phone_number}</p>
                </div>
                <div className="address">
                  <p>Address</p>
                  <p>{user?.address || "Nil"}</p>
                </div>
              </div>
            )}

            <div style={{ marginBottom: 12 }}>
              <Link to="/transactions" onClick={() => setShowProfile(false)}>
                <Button
                  block
                  size="large"
                  type="primary"
                  style={{
                    backgroundColor: "#0F0F10",
                    borderColor: "#0F0F10",
                    color: "#ffffff",
                    fontWeight: 600,
                    borderRadius: 8,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 8,
                  }}
                >
                  <ShoppingOutlined /> My Orders & Tracking
                </Button>
              </Link>
            </div>

            <div className="logout">
              <Button block size="large" onClick={logoutUser}>
                Log out
              </Button>
            </div>
          </div>
        </Modal>
      )}
      <header
        className="ls-header"
        style={inOrganise ? { borderBottomColor: inOrganise } : undefined}
      >
        <Link to={merchantUrl || window.location} className="ls-header__brand">
          {brandLogo && <img src={brandLogo} alt={`${brandName} logo`} />}
          {brandName && (
            <span className="ls-header__brand-name">{brandName}</span>
          )}
        </Link>

        <div className="ls-header__actions">
          {showBranchPicker && (
            <div className="ls-header__branch">
              <EnvironmentOutlined style={{ fontSize: 15, flexShrink: 0 }} />
              <Select
                size="small"
                value={selectedBranchId !== null && selectedBranchId !== undefined ? (isNaN(selectedBranchId) ? selectedBranchId : Number(selectedBranchId)) : undefined}
                onChange={onBranchSelect}
                style={{ width: "100%", minWidth: "90px", maxWidth: "160px" }}
                dropdownMatchSelectWidth={false}
                dropdownStyle={{ minWidth: 180 }}
                dropdownClassName="header-branch-select-dropdown"
                popupClassName="header-branch-select-dropdown"
                bordered={false}
                placeholder="Select branch"
                getPopupContainer={() => document.body}
              >
                {merchantBranches.map((branch) => {
                  const branchName = branch.name.toLowerCase().includes("home") ? "HQ" : branch.name;
                  return (
                    <Option key={branch.id} value={branch.id}>
                      {branchName}
                    </Option>
                  );
                })}
              </Select>
            </div>
          )}

          <Link
            to="/transactions"
            className="ls-header__orders-btn"
            title="Track Orders"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              height: 38,
              padding: "0 12px",
              borderRadius: "9999px",
              background: "var(--ls-surface, #F5F5F7)",
              color: "var(--ls-ink, #0F0F10)",
              fontSize: 13,
              fontWeight: 600,
              textDecoration: "none",
              border: "1px solid var(--ls-border, #E6E6E8)",
            }}
          >
            <ShoppingOutlined style={{ fontSize: 15 }} />
            <span className="ls-header__orders-text">Orders</span>
          </Link>

          <button
            type="button"
            id="header-account-button"
            className="ls-header__account"
            onClick={() => (user ? setShowProfile(true) : openLoginModal && openLoginModal())}
            aria-label={user ? "Show member pass" : "Sign in"}
          >
            {user ? (
              <span className="ls-header__avatar">{initials}</span>
            ) : (
              <span className="ls-header__avatar">
                <HiOutlineQrCode size={16} />
              </span>
            )}
            <span className="ls-header__greeting">
              {user ? user?.first_name || "My pass" : "Sign in"}
            </span>
          </button>
        </div>
      </header>
    </>
  );
};

export default Header;
